import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/scss/index.scss';
import '@/assets/template/plugins/fontawesome-free/css/all.min.css';
import '@/assets/template/adminlte.min.css';
import './plugins/vue-head.js';
import './plugins/vue-highlight.js';
import './plugins/moment.js';
import './plugins/lodash.js';
import hepburn from 'hepburn';
window.hepburn = hepburn;
Vue.use(require('vue-cookies'));
Vue.config.productionTip = false;
Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value)
});
const $ = require('jquery');

let vue = new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App)
}).$mount('#app');

window.$ = $;
window.$i18n = i18n;
window.$cookies = vue.$cookies;
window.$store = store;
window.$vue = vue;
